export const USER_LOCALE_STORAGE_KEY = 'mm-user-locale';
export const CACHE_REVALIDATE_TIME = 15 * 60;
export const DEFAULT_LOCALE = 'en-US';

export const LANGUAGES = {
  'en-US': 'English',
  'de-DE': 'German',
  'pt-BR': 'Portuguese (Brazil)',
  'es-ES': 'Spanish',
} as const;

export const LOCALES = ['en-US', 'pt-BR', 'es-ES', 'de-DE'];
export type TLOCALES = keyof typeof LANGUAGES;
